import { useAuthContext } from '@authentication/AuthContext'
import AnalyticsPage from '@pages/Analytics/AnalyticsPage'
import ReferrerAnalyticsPage from '@pages/Analytics/ReferrerAnalyticsPage'
import ErrorsV2 from '@pages/ErrorsV2/ErrorsV2'
import LogsPage from '@pages/LogsPage/LogsPage'
import { PlayerPage } from '@pages/Player/PlayerPage'
import { SetupPage } from '@pages/Setup/SetupPage'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { RelatedResourcePanel } from '@/components/RelatedResources/RelatedResourcePanel'
import { SignInRedirect } from '@/pages/Auth/SignInRedirect'
import { SettingsRouter } from '@/pages/SettingsRouter/SettingsRouter'

const BASE_PATH = 'sessions'

const ApplicationRouter: React.FC = () => {
	const { isLoggedIn } = useAuthContext()

	return (
		<>
			<Routes>
				<Route
					path="sessions/:session_secure_id?"
					element={<PlayerPage />}
				/>

				<Route
					path="errors/:error_secure_id?/:error_tab_key?/:error_object_id?"
					element={<ErrorsV2 />}
				/>

				{isLoggedIn ? (
					<>
						<Route
							path="logs/:log_cursor?"
							element={<LogsPage />}
						/>
						<Route
							path="analytics/referrer"
							element={<ReferrerAnalyticsPage />}
						/>
						<Route path="analytics" element={<AnalyticsPage />} />
						<Route path="setup/*" element={<SetupPage />} />
						<Route path="settings/*" element={<SettingsRouter />} />
						<Route
							path="*"
							element={<Navigate to={BASE_PATH} replace />}
						/>
					</>
				) : (
					<Route path="*" element={<SignInRedirect />} />
				)}
			</Routes>
			<RelatedResourcePanel />
		</>
	)
}

export default ApplicationRouter
